import { Typography, useTheme } from '@mui/material';
import { ContainerForm, TituloContent } from './SimulationMuiComponents';

export const ContributionsSectionTitle = ({ textTitle }) => {
  const theme = useTheme();
  return (
    <>
      <TituloContent>
        <Typography
          sx={{
            fontWeight: theme.typography.signInWelcome.fontWeight,
            color: theme.palette.primary.main,
            fontSize: theme.typography.h1.fontSize,
            [theme.breakpoints.down('md')]: {
              fontSize: theme.typography.profile.fontSize,
              marginLeft: '0px',
            },
            [theme.breakpoints.down('sm')]: {
              fontSize: theme.typography.availableBalance.fontSize,
              marginLeft: '0px',
            },
          }}>
          {textTitle}
        </Typography>
      </TituloContent>
    </>
  );
};
